export const POPUP_HEIGHT = 700;
export const POPUP_WIDTH = 600;
export const OAUTH_STATE_KEY = 'react-use-oauth2-state-key';
export const OAUTH_RESPONSE = 'react-use-oauth2-response';
export const DEFAULT_EXCHANGE_CODE_FOR_TOKEN_METHOD = 'POST';

export const OAUTH_CLIENT_USERNAME: string = "2yc3NodeOAuth";
export const OAUTH_CLIENT_PASSWORD: string = "jdkf98739jdf";